import { useState, useEffect } from "react";
import styles from "./Drawer.module.css";
import packageJson from "./../../../../package.json";
import { useDispatch, useSelector } from "react-redux";
import { Drawer as AntDrawer } from "antd";
import { _Cart_Clean } from "../../../store/actions/cart_actions";
import {
  _logout_user,
  set_cid,
  set_cpid,
} from "../../../store/actions/login_actions";
import { calculator } from "../../../base/utils";

// icons
import IconUser from "../../../assets/images/icons/drawer-user.png";
import IconFaq from "../../../assets/images/icons/drawer-faq.png";
import IconLogOut from "../../../assets/images/icons/drawer-logout.png";
import IconSupport from "../../../assets/images/icons/drawer-support-rv.png";
import IconLocation from "../../../assets/images/icons/drawer-location.png";
import IconReturn from "../../../assets/images/icons/drawer-return-order.png";
import IconCalendar from "../../../assets/images/icons/calendar.png";
import IconService from "../../../assets/images/icons/drawer-service.png";
import { ReactComponent as BottomArrow } from "../../../assets/svg/bottom-arrow.svg";
import { ReactComponent as MenuIcon } from "./../../../assets/svg/menu.svg";
import IconStocks from "./../../../assets/images/icons/stock.png";
import { client } from "../../../services/api/graphql/initialize";
import { useTranslation } from "react-i18next";
import PusherService from "../../../services/pusher/pusher-service";
import { license } from "../../../base/env";
import IconEmployee from "../../../assets/images/icons/employee-icon.png";
import clsx from "clsx";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { LangLink } from "../LangLink/LangLink";

const Drawer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useLangNavigate();
  const Login = useSelector((state) => state.Login);
  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    calculator();
  }, []);

  const _logout = async () => {
    dispatch(_Cart_Clean());
    dispatch(set_cid(""));
    dispatch(set_cpid("gmall"));
    try {
      localStorage.removeItem("cid");
    } catch (_) {
      /* ignore */
    }
    calculator();
    try {
      client.stop();
      await client.clearStore();
    } catch (e) {
      console.error("Error stopping/clearing Apollo store:", e);
    }
    dispatch(_logout_user());
    navigate("/");
  };

  return (
    <div>
      <button
        data-testId="hamburger-menu-button"
        className={clsx(styles.hamburgerMenuButton, {
          [styles.rtl]: i18n.dir() === "rtl",
        })}
        onClick={() => setVisible(true)}
      >
        <MenuIcon />
      </button>
      <AntDrawer
        classNames={{
          header: styles.headerStyle,
        }}
        styles={{
          header: {
            borderBottom: "none",
            paddingInline: "16px",
            paddingBottom: "0px",
          },
          body: {
            padding: "0",
          },
        }}
        zIndex={9999999999}
        placement={i18n.dir() === "ltr" ? "left" : "right"}
        onClose={() => setVisible(false)}
        open={visible}
        width={300}
      >
        <div className="drawer-main">
          <div className="drawer-menu">
            <ul>
              <li className="drawer-link-item">
                <LangLink className="drawer-link-container" to="/country/edit">
                  <img
                    src={IconLocation}
                    className="drawer-link-item-img"
                    alt="Country"
                  />
                  {`${Login.country_name}`}
                  <BottomArrow
                    className={`
                    drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                      }
                  `}
                  />
                </LangLink>
              </li>
              {Login?.is_login ? (
                <li className="drawer-link-item">
                  <LangLink className="drawer-link-container" to="/profile/">
                    <img
                      src={IconUser}
                      className="drawer-link-item-img"
                      alt="User Account"
                    />
                    <span className="drawer-profile-text">
                      <span>
                        {Login?.first_name && Login?.last_name ? (
                          <>
                            {Login?.first_name} {Login?.last_name}
                          </>
                        ) : (
                          "User Account"
                        )}
                      </span>
                      <small dir="ltr">+968{Login?.phone_number}</small>
                    </span>
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                    `}
                    />
                  </LangLink>
                </li>
              ) : null}
              {Login?.is_login ? (
                <li className="drawer-link-item">
                  <LangLink className="drawer-link-container" to="/appointment">
                    <img
                      src={IconCalendar}
                      className="drawer-link-item-img"
                      alt="Appointments"
                    />
                    {t("common.appointment")}
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                    `}
                    />
                  </LangLink>
                </li>
              ) : null}
              {Login?.is_login ? (
                <li className="drawer-link-item">
                  <LangLink
                    className="drawer-link-container"
                    to="/new-service/"
                  >
                    <img
                      src={IconService}
                      className="drawer-link-item-img"
                      alt="New Service"
                    />
                    {t("drawer.new_service")}
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                    `}
                    />
                  </LangLink>
                </li>
              ) : null}

              {Login?.is_login ? (
                <li className="drawer-link-item">
                  <LangLink className="drawer-link-container" to="/stocks/">
                    <img
                      src={IconStocks}
                      className="drawer-link-item-img"
                      alt="Contact Us"
                    />
                    {t("drawer.stock")}
                    <BottomArrow
                      className={`
                    drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                  `}
                    />
                  </LangLink>
                </li>
              ) : null}

              {Login?.is_login ? (
                <li className="drawer-link-item">
                  <LangLink className="drawer-link-container" to="/employees/">
                    <img
                      src={IconEmployee}
                      className="drawer-link-item-img"
                      alt="New Service"
                    />
                    {t("drawer.employees")}
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                    `}
                    />
                  </LangLink>
                </li>
              ) : null}

              {/* <li className="drawer-link-item">
                <LangLink className="drawer-link-container" to="/support/">
                  <img
                    src={IconSupport}
                    className="drawer-link-item-img"
                    alt="Contact Us"
                  />
                  {t("drawer.contact")}
                  <BottomArrow
                    className={`
                    drawer-left-arrow ${
                      i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                    }
                  `}
                  />
                </LangLink>
              </li> */}
              {/* {Login?.is_login ? (
                <li className="drawer-link-item">
                  <LangLink className="drawer-link-container" to="/return/">
                    <img
                      src={IconReturn}
                      className="drawer-link-item-img"
                      alt="Return Order"
                    />
                    {t("drawer.return")}
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${
                        i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                      }
                    `}
                    />
                  </LangLink>
                </li>
              ) : null} */}



              <li className="drawer-link-item">
                <LangLink className="drawer-link-container" to="/support/">
                  <img
                    src={IconSupport}
                    className="drawer-link-item-img"
                    alt="Help"
                  />
                  {t("drawer.help")}
                  <BottomArrow
                    className={`
                    drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                      }
                  `}
                  />
                </LangLink>
              </li>

              <li className="drawer-link-item">
                <LangLink
                  className="drawer-link-container"
                  to="/terms-and-policy/"
                >
                  <img
                    src={IconFaq}
                    className="drawer-link-item-img"
                    alt="Terms And Policy"
                  />
                  {t("drawer.terms_and_policy")}
                  <BottomArrow
                    className={`
                    drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                      }
                  `}
                  />
                </LangLink>
              </li>

              {Login?.is_login ? (
                <li className="drawer-link-item">
                  <button
                    className="drawer-link-container"
                    onClick={() => {
                      PusherService.logout();
                      _logout();
                    }}
                  >
                    <img
                      src={IconLogOut}
                      className="drawer-link-item-img"
                      alt="Sign Out"
                    />
                    <span className="text-align-right">
                      {t("drawer.sign_out")}
                    </span>
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                    `}
                    />
                  </button>
                </li>
              ) : (
                <li className="drawer-link-item ">
                  <LangLink to="/login/d/" className="drawer-link-container">
                    <img
                      src={IconLogOut}
                      className="drawer-link-item-img"
                      alt="Sign In / Sign Up"
                    />
                    {t("drawer.sign_in")}
                    <BottomArrow
                      className={`
                      drawer-left-arrow ${i18n.dir() === "rtl" ? "drawer-icon-rtl-rotate" : ""
                        }
                    `}
                    />
                  </LangLink>
                </li>
              )}
            </ul>
          </div>

          {/* {visible ? <div className="version">{`نسخه ${version}`}</div> : null} */}
        </div>
        <div className={styles.BottomContainer}>
          <div>License Number: {license}</div>
          <div>version: {process.env.REACT_APP_VERSION ?? "DEV"}</div>
          <div>© Gmall 2025 Schatco GmbH. All Rights Reserved</div>
        </div>
      </AntDrawer>
    </div>
  );
};

export default Drawer;
